module.exports = __webpack_public_path__ + "static/media/cameradefault.9a7cc4b7.svg";